var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
// @ts-ignore Flex is re-exported from @theme-ui/components.
import { Flex as BaseFlex, jsx } from "theme-ui";
/**
 * A light abstraction over CSS flex-box.
 *
 * @param {object} props
 * @param {import("csstype").Property.FlexDirection | Array<import("csstype").Property.FlexDirection | null>} [props.direction] The flex-direction CSS attribute.
 * @param {'wrap'|'wrap-reverse'|'nowrap'} [props.wrap] The flex-wrap CSS attribute.
 * @param {'flex-start'|'flex-end'|'center'|'space-around'|'space-between'|'space-evenly'|'stretch'} [props.justify] The justify-content CSS attribute.
 * @param {'flex-start'|'flex-end'|'center'|'stretch'|'baseline'} [props.align] The align-items CSS attribute.
 * @param {boolean} [props.inline] Makes this an inline flex box.
 * @param {number | (number | null)[]} [props.gap] The gap between children. This is simulated via CSS.
 * @param {import('react').ReactNode} [props.children]
 * @param {string} [props.className]
 * @param {string} [props.id]
 * @param {React.ElementType} [props.as] An alternative component to render instead of a general-purpose <div>.
 * @returns {React.ReactElement}
 */
export default function Flex(_a) {
    var { direction, wrap, gap, justify, align, inline, children } = _a, rest = __rest(_a, ["direction", "wrap", "gap", "justify", "align", "inline", "children"]);
    if (!gap) {
        // The simple case without any polyfills
        return (_jsx(BaseFlex, Object.assign({ sx: {
                display: inline ? "inline-flex" : "flex",
                flexDirection: direction,
                flexWrap: wrap,
                justifyContent: justify,
                alignItems: align,
            } }, rest, { children: children })));
    }
    const isColumn = direction && direction.includes("column");
    const isReverse = direction &&
        (direction.includes("column-reverse") || direction.includes("row-reverse"));
    const columnGap = isColumn ? undefined : gap;
    const rowGap = !isColumn ? undefined : gap;
    return (_jsx(BaseFlex, Object.assign({ sx: {
            display: inline ? "inline-flex" : "flex",
            flexDirection: direction,
            flexWrap: wrap,
            justifyContent: justify,
            alignItems: align,
            // A "polyfill" for the gap property.
            "> :not(:last-child)": !isReverse && {
                marginRight: columnGap,
                marginBottom: rowGap,
            },
            "> :not(:first-child)": isReverse && {
                marginRight: columnGap,
                marginBottom: rowGap,
            },
            // The real gap property.
            // '@supports  (gap: 8px)': {
            //   columnGap: columnGap,
            //   rowGap: rowGap,
            //   // Undo the polyfill for supporting browsers.
            //   marginRight: columnGap && 0,
            //   marginBottom: rowGap && 0,
            //   '> *': {
            //     marginRight: columnGap && 0,
            //     marginBottom: rowGap && 0,
            //   },
            // },
        } }, rest, { children: children })));
}
//# sourceMappingURL=Flex.js.map